import ChartsService from '@/services/benchmarks/ChartsService';
import { getBenchmarkId, chartLegendOrder } from '@/utils';

import { chartsMutationTypes } from '../mutation-types';

export async function fetchTotalPublications({ commit, rootState, rootGetters }) {
  try {
    const channels = rootState.benchmarks.channels;

    commit(chartsMutationTypes.TOTAL_PUBLICATIONS_LOADING, true);
    commit(chartsMutationTypes.TOTAL_PUBLICATIONS_ERROR, false);

    const groupIdListJoined = rootGetters['ui/getterGroupIdList'].join(',');
    const channelListJoined = rootGetters['benchmarks/channelsLabels'].join(',');
    const handleChannelSelected = rootState.ui.channel === 'Todas' ? channelListJoined : rootState.ui.channel;

    const { series, categories } = await ChartsService.getTotalPublications({
      'benchmark-id': getBenchmarkId(),
      'group-id': groupIdListJoined,
      'start-date': rootState.ui.dateRange.start,
      'end-date': rootState.ui.dateRange.end,
      channel: handleChannelSelected,
    });

    if (!Array.isArray(series) || !Array.isArray(categories)) throw new Error();

    const seriesWithColor = series.map((serie) => ({
      ...serie,
      index: chartLegendOrder.socialNetwork[serie.name.toLowerCase()],
      color: channels.find(c => c.channel === serie.name)?.hex_color,
    }));

    commit(chartsMutationTypes.TOTAL_PUBLICATIONS_DATA, { series: seriesWithColor, categories });
  } catch (e) {
    commit(chartsMutationTypes.TOTAL_PUBLICATIONS_ERROR, true);
    console.error(e);
    return e;
  } finally {
    commit(chartsMutationTypes.TOTAL_PUBLICATIONS_LOADING, false);
  }
}
